import { RICH_TEXT } from '../common';
import { PRODUCT_MEDIA_FIRST_TWO } from './productMedia';
import { PRODUCT_SLUG } from './productSlug';

export const PRODUCT_WITH_VARIANTS = `
  product -> {
    ${PRODUCT_SLUG},
    "mostPopularVariantId": mostPopular->store.gid,
    "bestValueVariantId": bestValue->store.gid,
    "media": ${PRODUCT_MEDIA_FIRST_TWO},
    "bulletPoints": bulletPointsV2[] { ${RICH_TEXT} },
    disclaimer,
    bundleProducts[defined(product.product)] {
      _key,
      isFree,
      "product": product.product-> {
        ${PRODUCT_SLUG}
      },
      "variant": coalesce(
        product.variant-> { "gid": store.gid },
        product.product-> { "gid": store.variants[0]->store.gid }
      )
    },
  },
  variants[] -> { "gid": store.gid }
`;
